<template>
	<div class="layer-project" data-project-name="pantos">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<!-- Page Contents -->
			<section class="project-visual">
				<div>
					<h1 class="project-tit">PANTOS</h1>
					<a href="http://www.pantos.com" class="link" target="_blank"
						>www.pantos.com</a
					>
				</div>
			</section>
			<!-- Details [s] -->

			<!-- overview -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						판토스/하이로지스틱스 통합 웹, 모바일 사이트를 개편하였습니다.
						<br class="blank pc" />주요 사업영역, 기업소개 등 콘텐츠를
						보강하였고, 사용자를 고려한 UI 개선작업이 진행 되었습니다.
						<br class="blank pc" />LG그룹사의 패밀리 룩을 유지하고 최신 디자인
						트렌드를 반영하여 글로벌 종합물류기업으로서의 판토스 브랜드 이미지를
						제고했습니다.
					</p>
					<div class="project-overview-icons">
						<dl>
							<dt class="icon">
								<img
									src="/static/img/project-detail/pantos/overview-icon01.png"
								/>
							</dt>
							<dd>Sea Freight</dd>
						</dl>
						<dl>
							<dt class="icon">
								<img
									src="/static/img/project-detail/pantos/overview-icon02.png"
								/>
							</dt>
							<dd>Air Freight</dd>
						</dl>
						<dl>
							<dt class="icon">
								<img
									src="/static/img/project-detail/pantos/overview-icon03.png"
								/>
							</dt>
							<dd>Express</dd>
						</dl>
						<dl>
							<dt class="icon">
								<img
									src="/static/img/project-detail/pantos/overview-icon04.png"
								/>
							</dt>
							<dd>Project Cargo</dd>
						</dl>
						<dl>
							<dt class="icon">
								<img
									src="/static/img/project-detail/pantos/overview-icon05.png"
								/>
							</dt>
							<dd>Warehousing</dd>
						</dl>
						<dl class="last">
							<dt class="icon">
								<img
									src="/static/img/project-detail/pantos/overview-icon06.png"
								/>
							</dt>
							<dd>Trucking</dd>
						</dl>
					</div>
				</div>
			</section>

			<!-- Details [e] -->
			<section class="section section01 full">
				<div class="inner-section">
					<div class="con-tit-area">
						<strong class="project-subtit">PC Web</strong>
					</div>
					<div class="pc-img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/pantos/sec1-cont-pc@m.png"
						/>
					</div>
					<div class="detail-img">
						<strong class="cont-tit"
							>Global Top10 <br class="blank mb" />Logistics Enterprise</strong
						>
						<p class="cont-desc">
							Pantos Logistics endeavors to create customer value in various
							logistics areas, <br class="blank tb" />such as project cargo,
							break bulk, general cargo, consolidation,
							<br class="blank pc" /><br class="blank tb" />door-to-door
							service, container freight, bonded transportation, customs
							clearance, delivery, <br class="blank tb" />storage, and
							consulting, through its global networks that
							<br class="blank pc" />aim to reduce
							<br class="blank tb" />customers' logistics cost and provide
							top-notch services as well as its network
							<br class="blank tb" />systems that connect major ports and
							airports worldwide.
						</p>
						<div class="cont-img img01">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/pantos/sec1-detail01@m.png"
							/>
						</div>
						<div class="cont-img img02">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/pantos/sec1-detail02@m.png"
							/>
						</div>
					</div>
				</div>
			</section>
			<section class="section full section02">
				<div class="inner-section">
					<div class="con-tit-area">
						<strong class="project-subtit">Mobile Web</strong>
					</div>
					<div class="detail-img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/pantos/sec2-cont-main@m.jpg"
						/>
					</div>
					<div class="mobile-swiper">
						<div class="swiper-wrapper">
							<div class="swiper-slide">
								<img
									src="/static/img/project-detail/pantos/sec2-cont-sub01.png"
								/>
							</div>
							<div class="swiper-slide">
								<img
									src="/static/img/project-detail/pantos/sec2-cont-sub02.png"
								/>
							</div>
							<div class="swiper-slide">
								<img
									src="/static/img/project-detail/pantos/sec2-cont-sub03.png"
								/>
							</div>
							<div class="swiper-slide">
								<img
									src="/static/img/project-detail/pantos/sec2-cont-sub04.png"
								/>
							</div>
						</div>
						<div class="swiper-pagination"></div>
					</div>
				</div>
			</section>
			<section class="section section03">
				<div class="inner-section">
					<div class="detail-cont cont01">
						<dl>
							<dt data-color="#000000"></dt>
							<dd>#000000</dd>
						</dl>
						<dl>
							<dt data-color="#6b6b6b"></dt>
							<dd>#6b6b6b</dd>
						</dl>
						<dl>
							<dt data-color="#a10b36"></dt>
							<dd>#a10b36</dd>
						</dl>
						<dl>
							<dt data-color="#8c734d"></dt>
							<dd>#8c734d</dd>
						</dl>
						<dl>
							<dt data-color="#a7a9ac"></dt>
							<dd>#a7a9ac</dd>
						</dl>
					</div>
					<ul class="detail-cont cont02">
						<li>
							<img
								src="/static/img/project-detail/pantos/sec3-cont-item01.png"
							/>
						</li>
						<li>
							<img
								src="/static/img/project-detail/pantos/sec3-cont-item02.png"
							/>
						</li>
						<li>
							<img
								src="/static/img/project-detail/pantos/sec3-cont-item03.png"
							/>
						</li>
						<li>
							<img
								src="/static/img/project-detail/pantos/sec3-cont-item04.png"
							/>
						</li>
						<li>
							<img
								src="/static/img/project-detail/pantos/sec3-cont-item05.png"
							/>
						</li>
						<li>
							<img
								src="/static/img/project-detail/pantos/sec3-cont-item06.png"
							/>
						</li>
					</ul>
				</div>
			</section>
			<section class="project-client">
				<strong class="a11y-hidden">pantos LOGISTICS</strong>
			</section>
			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();

		var $window = $(window);
		var winW = $window.outerWidth();
		var flag = true;
		var isSlider = true;
		var pcwebSwiper;

		var pcWeb = function () {
			if (isSlider) {
				isSlider = false;
				pcwebSwiper = new Swiper(".mobile-swiper", {
					slidesPerView: "auto",
					pagination: {
						el: ".swiper-pagination",
					},
				});
			}
		};

		if (winW < 712) {
			pcWeb();
		} else {
			isSlider = true;
		}
		$window.on("resize", function () {
			winW = $window.outerWidth();
			if (winW < 712) {
				if (flag) {
					flag = false;
					pcWeb();
				}
			} else {
				flag = true;
				if (!isSlider) {
					isSlider = true;
					pcwebSwiper.destroy();
					$(".swiper-pagination").children().remove();
				}
			}
		});
	},
	methods: {},
};
</script>

<style scoped>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
/* Common */
div[class^="rwd"] {
	display: none;
}
.section.full .con-tit-area {
	max-width: 1280px;
	margin: 0 auto;
}
@media screen and (max-width: 711px) {
	div[class="rwd-mb"] {
		display: inline-block;
	}
	.section.full .con-tit-area {
		padding: 0 15px;
	}
	.blank.mb {
		display: block;
	}
	.blank.tb,
	.blank.pc {
		display: none;
	}
}
@media screen and (min-width: 712px) {
	div[class="rwd-tb"] {
		display: inline-block;
	}
	.blank.tb {
		display: block;
	}
	.blank.mb,
	.blank.pc {
		display: none;
	}
}
@media screen and (min-width: 1280px) {
	div[class="rwd-tb"] {
		display: none;
	}
	div[class="rwd-pc"] {
		display: inline-block;
	}
	.blank.pc {
		display: block;
	}
	.blank.mb,
	.blank.tb {
		display: none;
	}
}

/* Project Visual, Project CI */
.project-client {
	background: #282a2c url(/static/img/project-detail/pantos/ci.png) 50% / auto
		43px no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/pantos/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/pantos/bg-overview@t.jpg);
	}
	.project-client {
		background-size: auto 55px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/pantos/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 110px;
	}
}

/* Overview */
.project-overview {
	background-color: #a40033;
	color: #fff;
}
.project-overview-icons {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
}
.project-overview-icons dl {
	text-align: center;
	letter-spacing: -0.2px;
}
@media screen and (max-width: 711px) {
	.project-overview-icons {
		margin-top: 20px;
	}
	.project-overview-icons dl {
		padding: 12px 0;
	}
	.project-overview-icons dt {
		width: 45px;
		height: 24px;
		margin: 0 7.61vw 15px;
	}
	.project-overview-icons dd {
		font-size: 14px;
	}
}
@media screen and (min-width: 712px) {
	.project-overview-icons {
		margin-top: 35px;
	}
	.project-overview-icons dl {
		position: relative;
	}
	.project-overview-icons dl:not(.last)::after {
		content: "";
		position: absolute;
		top: calc(50% - 14px);
		right: calc(50% - 10vw);
		display: block;
		width: 25px;
		height: 1px;
		background-color: #fff;
	}
	.project-overview-icons dt {
		width: 45px;
		height: 24px;
		margin: 0 10px 15px;
	}
	.project-overview-icons dd {
		font-size: 12px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview-icons {
		margin: 110px 0;
	}
	.project-overview-icons dl:not(.last)::after {
		top: calc(50% - 20px);
		right: calc(0% - 75px);
		width: 70px;
		height: 1px;
	}
	.project-overview-icons dt {
		width: 90px;
		height: 50px;
		margin: 0 20px 25px;
	}
	.project-overview-icons dd {
		font-size: 20px;
	}
}
/* section01 :PC Web */
.layer-project-detail > section.full.section01 {
	padding: 0;
}
.section01 {
	position: relative;
}
.section01 .inner-section {
	background: url(/static/img/project-detail/pantos/sec1-bg.jpg) no-repeat;
	background-position: top center;
}
.section01 .con-tit-area .project-subtit {
	position: relative;
	color: #fff;
	z-index: 10;
}
.section01 .pc-img {
	position: absolute;
	left: 0;
	width: 100%;
	text-align: center;
}
.section01 .detail-img {
	text-align: center;
}
.section01 .detail-img .cont-tit {
	display: block;
	line-height: 1.2;
	letter-spacing: -0.25px;
}
@media screen and (max-width: 711px) {
	.section01 .inner-section {
		background-size: auto 78.125vw;
	}
	.section01 .con-tit-area {
		padding: 0 15px;
	}
	.section01 .con-tit-area .project-subtit {
		padding-top: 30px;
	}
	.section01 .pc-img {
		top: 123px;
	}
	.section01 .pc-img img {
		width: 91.25vw;
	}
	.section01 .detail-img {
		margin-top: 78.125vw;
	}
	.section01 .detail-img .cont-tit {
		font-size: 20px;
	}
	.section01 .detail-img .cont-desc {
		font-size: 14px;
		display: none;
	}
	.section01 .detail-img .cont-img.img01 {
		margin-top: 27px;
	}
}
@media screen and (min-width: 712px) {
	.section01 .inner-section {
		padding-top: 35px;
		background-size: auto 47.12vw;
	}
	.section01 .con-tit-area {
		padding: 0 40px;
	}
	.section01 .pc-img {
		top: 21.13vw;
	}
	.section01 .pc-img img {
		width: 54.35vw;
	}
	.section01 .detail-img {
		margin-top: 48.45vw;
	}
	.section01 .detail-img .cont-tit {
		font-size: 20px;
	}
	.section01 .detail-img .cont-desc {
		margin-top: 20px;
		font-size: 14px;
	}
	.section01 .detail-img .cont-img.img01 {
		margin-top: 30px;
	}
}
@media screen and (min-width: 1280px) {
	.layer-project-detail > section.full.section01 {
		max-width: 1920px;
	}
	.section01 .inner-section {
		background-size: 1920px auto;
	}
	.section01.full .con-tit-area {
		padding-top: 86px;
	}
	.section01 .pc-img {
		top: 220px;
	}
	.section01 .pc-img img {
		width: auto;
	}
	.section01 .detail-img {
		margin-top: 650px;
	}
	.section01 .detail-img .cont-tit {
		font-size: 30px;
	}
	.section01 .detail-img .cont-desc {
		margin-top: 20px;
		font-size: 14px;
		line-height: 1.8;
	}
	.section01 .detail-img .cont-img.img01 {
		margin: 75px 0 100px;
	}
}
.section02 .inner-section {
	position: relative;
}
.section02 .detail-img {
	text-align: center;
}
@media screen and (max-width: 711px) {
	.section02 .mobile-swiper {
		width: 60.625vw;
		margin: 43px auto 0;
	}
	.section02 .swiper-slide {
		width: 100%;
		margin: 0 -10px;
	}
	.section02 .swiper-slide {
		width: 100%;
	}
}
@media screen and (min-width: 712px) {
	.section02 .inner-section {
		padding: 0 40px;
	}
	.section02 .mobile-swiper {
		margin-top: 42px;
	}
	.section02 .swiper-slide {
		width: 27.24vw;
		margin: 0 -2.2vw;
	}
}
@media screen and (min-width: 1280px) {
	.section02 .con-tit-area {
		padding: 0 40px;
	}
	.section02 .mobile-swiper {
		margin-top: 118px;
	}
	.section02 .swiper-wrapper {
		display: flex;
		justify-content: center;
	}
	.section02 .swiper-slide {
		width: 388px;
		margin: 0 -30px;
	}
}
.section03 {
	background-color: #f5f5f5;
}
.section03 .detail-cont {
	display: flex;
	flex-wrap: wrap;
}
.section03 .detail-cont dt {
	border-radius: 50%;
	margin: 0 auto;
}
.section03 .detail-cont dl {
	text-align: center;
}
.section03 .cont01 dt {
	border-radius: 50%;
}
.section03 .cont01 dt[data-color="#000000"] {
	background-color: #000000;
}
.section03 .cont01 dt[data-color="#6b6b6b"] {
	background-color: #6b6b6b;
}
.section03 .cont01 dt[data-color="#a10b36"] {
	background-color: #a10b36;
}
.section03 .cont01 dt[data-color="#8c734d"] {
	background-color: #8c734d;
}
.section03 .cont01 dt[data-color="#a7a9ac"] {
	background-color: #a7a9ac;
}
@media screen and (max-width: 711px) {
	.section03 .cont01 {
		margin-bottom: 40px;
	}
	.section03 .cont01 {
		justify-content: flex-start;
	}
	.section03 .cont01 dl {
		padding: 13px 8.2vw;
	}
	.section03 .cont01 dt {
		width: 45px;
		height: 45px;
	}
	.section03 .cont01 dd {
		margin-top: 10px;
	}
	.section03 .cont02 {
		justify-content: space-between;
		margin-bottom: 20px;
	}
	.section03 .cont02 li {
		width: 43.5vw;
		margin-bottom: 14px;
	}
}
@media screen and (min-width: 712px) {
	.section03 .detail-cont {
		margin-bottom: 40px;
		justify-content: space-between;
	}
	.section03 .cont01 dl {
		padding: 13px 21px;
	}
	.section03 .cont01 dt {
		width: 45px;
		height: 45px;
	}
	.section03 .cont01 dd {
		margin-top: 10px;
	}
	.section03 .cont02 li {
		width: 25.9vw;
		margin-bottom: 25px;
	}
	.section03 .cont02 li img {
		width: 100%;
	}
}
@media screen and (min-width: 1280px) {
	.section03 .detail-cont {
		margin-bottom: 60px;
		justify-content: space-between;
	}
	.section03 .cont01 {
		margin-top: 150px;
	}
	.section03 .cont01 dl {
		padding: 0 16px;
	}
	.section03 .cont01 dt {
		width: 90px;
		height: 90px;
	}
	.section03 .cont01 dd {
		margin-top: 16px;
		font-size: 16px;
	}
	.section03 .cont02 {
		margin-bottom: 100px;
	}
	.section03 .cont02 li {
		width: auto;
		margin-bottom: 40px;
	}
	.section03 .cont02 li img {
		width: 100%;
	}
}
@media screen and (max-width: 320px) {
	.section03 .cont01 dl {
		padding: 13px 21px;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/pantos.vue